import { createTheme as m } from "./highrise678.mjs";
import i from "./highrise975.mjs";
import p from "./highrise955.mjs";
import s from "./highrise949.mjs";
import { composite as a } from "./highrise707.mjs";
function c(r) {
  const {
    borderRadius: t,
    boxShadow2: e,
    baseColor: o
  } = r;
  return Object.assign(Object.assign({}, i), {
    borderRadius: t,
    boxShadow: e,
    color: a(o, "rgba(0, 0, 0, .85)"),
    textColor: o
  });
}
const g = m({
  name: "Tooltip",
  common: s,
  peers: {
    Popover: p
  },
  self: c
});
export {
  g as default
};
